import { withLazy } from 'app/hocs/withLazy'

export const ScreenPopPrivacy = withLazy(
  () => import('features/ScreenPopPrivacy/pages/ScreenPopPrivacy'),
)
